<template>
  <Modal
    class="cc-modal"
    width="500"
    footer-hide
    v-model="visibility"
    title="修改邮箱"
  >
    <div class="content" style="position: relative">
      <loading :loading="loading" style="z-index: 11"></loading>
      <div class="section">
        <div style="width: 400px; margin:0 auto 20px;">
          <Steps :current="navStepCurrent">
              <Step v-for="item in stepList" :key="item.id" :title="item.name"></Step>
          </Steps>
        </div>
        <template v-if="navStepCurrent === 1">
          <div class="bj-rows">
            <div class="name">验证方式：</div>
            <Select v-model="checkType" style="width: 270px" :disabled="codeDisabled">
              <Option v-for="item in checkTypeList" :value="item.value" :key="item.value">{{ item.name }}</Option>
            </Select>
          </div>
          <div class="bj-rows" style="margin-top: 20px;">
            <div class="name">{{checkType === 0 ? '手机号码：' : '邮箱：'}}</div>
            <Input
              class="bj-input-h45 bj-hover-input-F85A36"
              :value="checkType === 0 ? user.mobile : user.email"
              disabled
              placeholder=""
              style="width: 270px"
              clearable
            />
          </div>
          <div class="bj-rows" style="margin: 20px 0;">
            <div class="name">验证码：</div>
            <div class="bj-rows">
              <Input
                class="bj-input-h45 bj-hover-input-F85A36"
                v-model="form.code"
                @on-keyup="form.code = form.code.replace(/[^\d]/g, '')"
                placeholder="请输入验证码"
                style="width: 120px"
                clearable
              />
              <smsBtn
                ref="smsBtn"
                height="45px"
                shape=""
                @tap="getCodeEvent"
                @change="onSmsBtnChange"
                style="width: 120px; margin-left: 30px"
              ></smsBtn>
            </div>
          </div>
        </template>
        <template v-if="navStepCurrent === 2">
          <div class="bj-rows">
            <div class="name">邮箱：</div>
            <Input
              class="bj-input-h45 bj-hover-input-F85A36"
              v-model="form.newEmail"
              placeholder="请输入邮箱"
              style="width: 270px"
              clearable
            />
          </div>
        </template>
      </div>
    </div>
    <div class="foot">
      <Button :loading="loading" @click="onConfirm" class="modal-confirm" style="margin-right: 20px">确定</Button>
      <Button @click="onCancel" class="modal-cancel">取消</Button>
    </div>
  </Modal>
</template>
<script>
import { userEmailUpdate, smsSend, postVerifyCode } from "api/user.js";
import { mapMutations, mapState } from "vuex";
import smsBtn from "components/smsBtn.vue";
import loading from "components/loading.vue";

export default {
  name: "updateEmailModal",
  components: {
    smsBtn,
    loading,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      navStepCurrent: 1,
      stepList: [
        {
          id: 1,
          name: "验证身份",
        },
        {
          id: 2,
          name: "设置新的邮箱",
        },
      ],
      checkType: 0,
      checkTypeList: [],
      codeDisabled: false,
      form: {
        code: "",
        newEmail: "",
        verifyCode: "",
      },
      loading: false,
    };
  },
  computed: {
    ...mapState(["user"]),
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.onShow();
          });
        }
      },
    },
  },
  methods: {
    ...mapMutations(["MUT_USER_INFO_EMAIL"]),
    onSmsBtnChange(val) {
      this.codeDisabled = val;
    },
    onCancel() {
      this.form = this.$options.data().form;
      this.navStepCurrent = 1;
      this.codeDisabled = false;
      this.visibility = false;
    },
    onShow() {
      this.form = this.$options.data().form;
      this.navStepCurrent = 1;
      this.codeDisabled = false;
      this.checkTypeList = []
      if (this.$refs.smsBtn) {
        this.$refs.smsBtn.reset();
      }
      if (this.user.mobile != null && this.user.mobile.length > 0) {
        this.checkType = 0
        this.checkTypeList.push({
          value: 0,
          name: '手机验证'
        })
      } else {
        this.checkType = 1
      }
      if (this.user.email != null && this.user.email.length > 0) {
        this.checkTypeList.push({
          value: 1,
          name: '邮箱验证'
        })
      }
    },
    async onConfirm() {
      try {
        if (this.navStepCurrent === 1) {
          if (!this.form.code) {
            this.$Message.warning("请输入验证码！");
            return false;
          }
          this.loading = true;
          const { code, data } = await postVerifyCode({ code: this.form.code, type: this.checkType });
          this.loading = false;
          if (code === 200) {
            this.codeDisabled = false;
            this.form.verifyCode = data.verifyCode;
            this.$refs.smsBtn.reset();
            this.navStepCurrent = 2;
          }
        } else if (this.navStepCurrent === 2) {
          if (!this.form.newEmail) {
            this.$Message.warning("请输入邮箱！");
            return false;
          }
          this.loading = true;
          let params = {
            yx: this.form.newEmail,
            ver: this.form.verifyCode,
          };
          const { code } = await userEmailUpdate(params);
          this.loading = false;
          if (code === 200) {
            this.MUT_USER_INFO_EMAIL(this.form.newEmail);
            this.$emit("submit-success", (res) => {
              if (res) {
                this.navStepCurrent = 1;
                this.onCancel();
                this.$Message.success("认证邮件已发送，请尽快验证！");
              }
            });
          }
          this.$refs.smsBtn.reset();
        }
      } catch (error) {
        this.loading = false;
        this.codeDisabled = false;
        this.$refs.smsBtn.reset();
      }
    },
    // 获取验证码
    getCodeEvent(callback) {
      smsSend(this.checkType)
        .then((res) => {
          if (res.code === 200 && res.result) {
            callback(true);
          }
        })
        .catch(() => {
          this.$refs.smsBtn.reset();
        });
    },
  },
};
</script>
<style lang="less" scoped>
.section{
  padding: 30px 0;
}
.name {
  color: #333333;
  font-size: 16px;
  min-width: 140px;
  text-align: right;
}
.foot {
  border-top: 1px solid #dcdee2;
  padding-top: 16px;
  display: flex;
  justify-content: center;
}
</style>

